import {DataObjectId} from 'yougile-model'
import {Backend} from '../../common/backend'

export class WebPush {
  public static init(userId: DataObjectId): void {
    const firebase = (window as any).firebase

    if (!firebase) {
      return
    }

    const messaging = firebase.messaging()
    messaging.requestPermission().then(() => {
      messaging.getToken().then((currentToken: string) => {
        if (currentToken) {
          WebPush.register(userId, currentToken)
        }
      })
      messaging.onTokenRefresh(() => {
        messaging.getToken().then((refreshedToken: string) => {
          WebPush.register(userId, refreshedToken)
        })
      })
      /*
      messaging.onMessage(function(payload) {
        logger.log("Message received. ", payload);
      });
      */
    })
  }

  private static register(
    userId: DataObjectId,
    token: string
  ): Promise<unknown> {
    const url = '/data/register-push-notification-recipient'
    const clientKind = 'web'
    const opts = {userId, token, clientKind}
    return Backend.postJSON(url, opts)
  }
}
